module.exports = __webpack_public_path__ + "static/media/title_survey.88e6bed9.svg";